var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Rating',{attrs:{"value":_vm.value,"max-value":_vm.maxValue,"custom-color":_vm.resolveColor(_vm.color, _vm.colorVariables),"rating-style":_vm.ratingStyle || 'star',"read-only":"","show-unselected":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }